import FormModal from 'components/organisms/FormModal/FormModal'
import * as FormConst from 'constants/FormConst'
import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CountryService from 'services/CountryService'
import HotelInfoService from 'services/HotelInfoService'
import {isObjectEmpty, setHotelInfoCompletedHistory, setHotelInfoInSession, setHotelOnboardingStatusInSession, setLockStatusInSession} from 'utilities/JSUtil'
import RouteConst from '../../constants/RouteConst'
import './LaunchOnboardingApplication.scss'
import HotelHistoryService from "../../services/HotelHistoryService";
import {getSessionItem} from "../../utilities/SessionHelper";
import SessionConst from "../../constants/SessionConst";

class LaunchOnboardingApplication extends Component {

  constructor(props) {
    super(props)

    const hotelCode = this.props.location?.state?.hotelCode
    const onboardingStatus = this.props.location?.state?.onboardingStatus

    if (!hotelCode || !onboardingStatus || isObjectEmpty(onboardingStatus)) {
      //Redirect to home page
      this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }

    this.state = {
      hotelCode: hotelCode,
      onboardingStatus: onboardingStatus,
      loadingMessage: 'Retrieving Hotel Information',
      isLoading: true,
      showErrorModal: false,
      hotelInfo: undefined
    }
  }

  async componentDidMount() {
    if (this.state.onboardingStatus.status === "COMPLETED") {
      await HotelHistoryService.getHotelOnboardingHistoryDetails(this.state.onboardingStatus.hotelOnboardingId, 0, 100)
        .then(async historyResponse => {
          let matchingRecords = historyResponse.hotelOnboardingHistoryItems.hotelOnboardingItems
              .filter( item => (item.type === "UPDATE" || item.type === "RECAP") && !isObjectEmpty(item.newEntity) && item.newEntity.status === "COMPLETED")
          // Sort by timestamp to get the latest record
          let hotelInfoCompletedHistoryRecord = matchingRecords.length > 0
              ? matchingRecords.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))[0]
              : undefined
            if(hotelInfoCompletedHistoryRecord) {
                setHotelInfoCompletedHistory(hotelInfoCompletedHistoryRecord)
                await this.populateCountriesForHotelInfo(hotelInfoCompletedHistoryRecord.newEntity.hotelInfo)
            } else {
                await this.getHotelInfo(this.state.hotelCode)
            }

          }).catch(error => {
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
          })
    } else {
      await this.getHotelInfo(this.state.hotelCode)
    }
  }

  async getHotelInfo(hotelCode) {
      await HotelInfoService.getHotelInfo({ hotelCode: hotelCode })
          .then(async hotelInfoResponse => {
              await this.populateCountriesForHotelInfo(hotelInfoResponse)
          }).catch(error => {
              this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
          })
  }

  async populateCountriesForHotelInfo (hotelInfo)  {
    await CountryService.getCountries({ hotelCode: this.state.hotelCode, queryParams: { countryCode: hotelInfo.address?.country } })
        .then(countryServiceResponse => {
          setHotelOnboardingStatusInSession(this.state.onboardingStatus)
          setLockStatusInSession(this.state.onboardingStatus)
          setHotelInfoInSession(hotelInfo, countryServiceResponse.countries[0])
          this.launchForm()
        }).catch(error => {
          this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        })
  }

  launchForm = () => {
    this.props.history.push(RouteConst.ROUTE_HOTEL_INFO_PAGE)
  }

  render() {

    return (
      <div className='launch-onboarding-page'>
        <FormModal
          id='launch-onboarding-application-loading-modal'
          title={FormConst.MODAL_UPDATE_ACTION_TITLE}
          body={<h6>{this.state.loadingMessage}</h6>}
          show={this.state.isLoading}
          isLoadingIndicator />
        <FormModal
          id='launch-onboarding-application-error-modal'
          title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
          body={<h5>{FormConst.MODAL_UPDATE_ACTION_ERROR_TEXT}</h5>}
          isError
          cancel={() => { this.setState({ showErrorModal: false }) }}
          show={this.state.showErrorModal} />
      </div>
    )
  }
}

export default withRouter(LaunchOnboardingApplication)